import axios from '../index'

export function getLocationForUser(params) {
  return axios.get(`/ajax/users/locations/${params.id}`)
}

export function getLocationsForSelect(params) {
  return axios.get('/ajax/users/locations/index_for_select', { params })
}

export function getCountries() {
  return axios.get('/ajax/users/locations/countries')
}

export function getCategories() {
  return axios.get('/ajax/users/locations/categories')
}
